import type { PopupMenuEntry, PopupMenuPlacement, PopupMenuProps } from '@kerfjs/ui/popup-menu';
import type { SafeHtml } from 'kerfjs';

/** How an action menu opens: a visible icon trigger, or (`context`) at the pointer with no
 *  trigger of its own (opened with `openPopupMenuAt`). */
export interface MenuTrigger {
  /** Accessible name of the trigger (or of the context menu). */
  label: string;
  /** Trigger icon; ignored by a context menu. */
  icon?: SafeHtml;
  context?: boolean;
  placement?: PopupMenuPlacement;
  disabled?: boolean;
  /** Application `data-*` metadata on the menu root, also the handle tests and pointer wiring find it by. */
  rootAttributes?: PopupMenuProps['rootAttributes'];
}

/** Kerf PopupMenu props for a trigger description and its entries; spread onto `<PopupMenu>`
 *  (HS2-0ZYSMS, HS2-DTZVFD). */
export function menuProps(trigger: MenuTrigger, items: readonly PopupMenuEntry[]): PopupMenuProps {
  if (trigger.context === true) {
    return { context: true, label: trigger.label, items, rootAttributes: trigger.rootAttributes };
  }
  return {
    label: trigger.label,
    icon: trigger.icon,
    caret: false,
    placement: trigger.placement ?? 'bottom-end',
    disabled: trigger.disabled,
    items,
    rootAttributes: trigger.rootAttributes,
  };
}
